import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from '../features/categorySlice';

// --- Load persisted state from localStorage ---
const loadState = () => {
    try {
        const serialized = localStorage.getItem('reduxState');
        if (!serialized) return undefined;
        return JSON.parse(serialized);
    } catch {
        return undefined;
    }
};

// --- Save state to localStorage ---
const saveState = (state) => {
    try {
        const serialized = JSON.stringify(state);
        localStorage.setItem('reduxState', serialized);
    } catch (_) {
    }
};

const persistedState = loadState();

export const store = configureStore({
    reducer: {
        category: categoryReducer
    },
    preloadedState: persistedState,
});


store.subscribe(() => {
    saveState({
        category: store.getState().category
    });
});
